import { createHashRouter, Navigate } from 'react-router-dom'
import { ErrorBoundary } from '@clofo/ui/error-boundary'
import { LoginPage } from './pages/login'
import { ForgotPasswordPage } from './pages/forgot-password'
import { RegistrationPage } from './pages/registration'
import { RegistrationExpiredPage } from './pages/registration-expired'
import { RegistrationNotFoundPage } from './pages/registration-not-found'
import { PasswordTokenErrorPage } from './pages/password-token-error'
import { ResetPasswordPage } from './pages/reset-password'
import { TfaVerifyPage } from './pages/tfa-verify'
import { TfaConfirmPage } from './pages/tfa-confirm'

const router = createHashRouter([
  {
    path: '/',
    element: (
      <ErrorBoundary>
        <LoginPage />
      </ErrorBoundary>
    ),
  },
  {
    path: 'passwords/forgot',
    element: (
      <ErrorBoundary>
        <ForgotPasswordPage />
      </ErrorBoundary>
    ),
  },
  {
    path: 'passwords/reset',
    element: (
      <ErrorBoundary>
        <ResetPasswordPage />
      </ErrorBoundary>
    ),
  },
  {
    path: 'passwords/token-error',
    element: (
      <ErrorBoundary>
        <PasswordTokenErrorPage />
      </ErrorBoundary>
    ),
  },
  {
    path: 'tfa/verify',
    element: (
      <ErrorBoundary>
        <TfaVerifyPage />
      </ErrorBoundary>
    ),
  },
  {
    path: 'tfa/confirm',
    element: (
      <ErrorBoundary>
        <TfaConfirmPage />
      </ErrorBoundary>
    ),
  },
  {
    path: 'registration',
    element: (
      <ErrorBoundary>
        <RegistrationPage />
      </ErrorBoundary>
    ),
  },
  {
    path: 'registration/expired',
    element: (
      <ErrorBoundary>
        <RegistrationExpiredPage />
      </ErrorBoundary>
    ),
  },
  {
    path: 'registration/not-found',
    element: (
      <ErrorBoundary>
        <RegistrationNotFoundPage />
      </ErrorBoundary>
    ),
  },

  /**
   * Test pages (logged-in placeholder and fake SSO identity provider), only available in
   * development or testing
   */
  ...(import.meta.env.DEV
    ? [
        {
          path: 'dev-logged-in',
          lazy: async () => {
            const { DevLoggedInPage } = await import('./pages/dev-logged-in')
            return {
              element: (
                <ErrorBoundary>
                  <DevLoggedInPage />
                </ErrorBoundary>
              ),
            }
          },
        },
        {
          // Fake IdP page the mock login_method handler points the SSO popup at — the path
          // here and the URL in mocks/handlers.ts must stay in sync.
          path: 'dev-sso',
          lazy: async () => {
            const { DevSsoPage } = await import('./pages/dev-sso')
            return {
              element: (
                <ErrorBoundary>
                  <DevSsoPage />
                </ErrorBoundary>
              ),
            }
          },
        },
        {
          // Fake iManage page for Login with Work; keep in sync with MOCK_DMS_URL in mocks/handlers.ts.
          path: 'dev-dms',
          lazy: async () => {
            const { DevDmsPage } = await import('./pages/dev-dms')
            return {
              element: (
                <ErrorBoundary>
                  <DevDmsPage />
                </ErrorBoundary>
              ),
            }
          },
        },
      ]
    : []),
  {
    path: '*',
    element: <Navigate to='/' replace />,
  },
])

export default router
